import { Component } from '@angular/core';

@Component({
  selector: 'app-pat-payment-panel-paygreen-restoflash',
  templateUrl: './pat-payment-panel-paygreen-restoflash.component.html',
})
export class PatPaymentPanelPaygreenRestoflashComponent {}
